module.exports = __webpack_public_path__ + "static/media/logoCollapsed.01149255.svg";